import React from 'react';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';
import Card, { CardTabItem } from '../../../components/bootstrap/Card';
import PdfRequestReport from './PdfRequestReport';
import CountryReport from './CountryReport';

const ReportsPage = () => {
	return (
		<PageWrapper title='Reports'>
			<Page container='fluid'>
				<Card hasTab tabButtonColor='primary'>
					<CardTabItem id='pdf-requests' title='PDF Request Report'>
						<PdfRequestReport />
					</CardTabItem>
					<CardTabItem id='country-report' title='IP Analytics Report'>
						<CountryReport />
					</CardTabItem>
				</Card>
			</Page>
		</PageWrapper>
	);
};

export default ReportsPage;
